import React, { useEffect, useState } from "react";
import {
    CButton,
    CButtonGroup,
    CCard,
    CCardBody,
    CCardFooter,
    CCardText,
    CCardTitle,
    CCol,
    CContainer,
    CFormCheck,
    CFormFloating,
    CFormInput,
    CFormLabel,
    CFormTextarea,
    CInputGroup,
    CInputGroupText,
    CRow,
} from "@coreui/react";
import DatePicker from "react-date-picker";
import { useSelector } from "react-redux";
import store from "../../storeWire";
import { FormFields } from "../CustomerLedgerMemo/common";
import {
    destroyFromServer,
    toServer,
    updateField,
} from "../../store/slice/customerAccount";
import { usePage } from "@inertiajs/inertia-react";
import CurrentBalance from "./CurrentBalance";
import axios from "axios";
import Helper from "../../application/helper";

const Common = (props) => {
    const auth = useSelector((state) => state.entities.auth);
    const p = usePage();
    const [action, setAction] = useState("edit");
    const account_type = {
        S: "Saving",
        L: "Loan",
    };
    const [readOnly, setReadonly] = useState(false);
    const d = useSelector((state) => state.entities.customerAccount);
    const onInputHandle = (value, name) => {
        let formattedValue = value; // Initialize with the value as is

        if (name === "frozen_at" && value) {
            let date = null;

            // Check if the value exists and is a valid date
            if (value) {
                date = new Date(value);
            } else {
                date = new Date();
            }

            // Validate the date
            if (!isNaN(date.getTime())) {
                // If you want to keep the time zone information, you can format the date manually
                const formattedDate =
                    [
                        date.getFullYear(),
                        ("0" + (date.getMonth() + 1)).slice(-2),
                        ("0" + date.getDate()).slice(-2),
                    ].join("-") +
                    " " +
                    [
                        ("0" + date.getHours()).slice(-2),
                        ("0" + date.getMinutes()).slice(-2),
                        ("0" + date.getSeconds()).slice(-2),
                    ].join(":");

                formattedValue = formattedDate;
            } else {
                console.warn("Invalid date provided for 'created_at'");
            }
        }

        if (name === "closed_at" && value) {
            let date = null;

            // Check if the value exists and is a valid date
            if (value) {
                date = new Date(value);
            } else {
                date = new Date();
            }

            // Validate the date
            if (!isNaN(date.getTime())) {
                // If you want to keep the time zone information, you can format the date manually
                const formattedDate =
                    [
                        date.getFullYear(),
                        ("0" + (date.getMonth() + 1)).slice(-2),
                        ("0" + date.getDate()).slice(-2),
                    ].join("-") +
                    " " +
                    [
                        ("0" + date.getHours()).slice(-2),
                        ("0" + date.getMinutes()).slice(-2),
                        ("0" + date.getSeconds()).slice(-2),
                    ].join(":");

                formattedValue = formattedDate;
            } else {
                console.warn("Invalid date provided for 'created_at'");
            }
        }

        if (name === "created_at") {
            let date = null;

            // Check if the value exists and is a valid date
            if (value) {
                date = new Date(value);
            } else {
                date = new Date();
            }

            // Validate the date
            if (!isNaN(date.getTime())) {
                // If you want to keep the time zone information, you can format the date manually
                const formattedDate =
                    [
                        date.getFullYear(),
                        ("0" + (date.getMonth() + 1)).slice(-2),
                        ("0" + date.getDate()).slice(-2),
                    ].join("-") +
                    " " +
                    [
                        ("0" + date.getHours()).slice(-2),
                        ("0" + date.getMinutes()).slice(-2),
                        ("0" + date.getSeconds()).slice(-2),
                    ].join(":");

                formattedValue = formattedDate;
            } else {
                console.warn("Invalid date provided for 'created_at'");
            }
        }

        if (name === "memo_created_at") {
            let date = null;

            // Check if the value exists and is a valid date
            if (value) {
                date = new Date(value);
            } else {
                date = new Date();
            }

            // Validate the date
            if (!isNaN(date.getTime())) {
                // If you want to keep the time zone information, you can format the date manually
                const formattedDate =
                    [
                        date.getFullYear(),
                        ("0" + (date.getMonth() + 1)).slice(-2),
                        ("0" + date.getDate()).slice(-2),
                    ].join("-") +
                    " " +
                    [
                        ("0" + date.getHours()).slice(-2),
                        ("0" + date.getMinutes()).slice(-2),
                        ("0" + date.getSeconds()).slice(-2),
                    ].join(":");

                formattedValue = formattedDate;
            } else {
                console.warn("Invalid date provided for 'created_at'");
            }
        }
        store.dispatch(
            updateField({
                field_name: name,
                value: formattedValue,
            })
        );
    };
    let getDate__frozen_at = () => {
        if (d?.frozen_at) {
            return new Date(d?.frozen_at);
        }
        return "";
    };
    let getDate = () => {
        if (d?.closed_at) {
            return new Date(d?.closed_at);
        }
        return "";
    };
    let getDate__created_at = () => {
        if (d?.created_at) {
            return new Date(d?.created_at);
        }
        return new Date();
    };
    let getDate__memo_created_at = () => {
        if (d?.memo_created_at) {
            return new Date(d?.memo_created_at);
        }
        return new Date();
    };
    useEffect(() => {
        if (p.props.customer_account) {
            setAction("edit");
        }
        if (p.props.current_route_name === "customer-account.delete") {
            setAction("delete");
        }
        if (props.action !== undefined) {
            setAction(props.action);
        }
        if (props.readOnly !== undefined) {
            setReadonly(true);
        }
    }, []);
    useEffect(() => {
        if (action === "delete") {
            setReadonly(true);
        }
    });
    const submitForm = () => {
        if (props.fromSubmitted !== undefined) {
            return props.fromSubmitted(d);
        }
        store.dispatch(toServer());
    };
    const destroyForm = () => {
        store.dispatch(destroyFromServer());
    };
    const backToHome = () => {
        window.history.back();
    };
    const getCustomerAccountNumber = (customer_account_number) => {
        if (
            customer_account_number &&
            customer_account_number.length > 1 &&
            customer_account_number.length < 15
        ) {
            axios
                .get(
                    Helper.route("customeraccount.show", {
                        customeraccount: customer_account_number,
                    })
                )
                .then((res) => {
                    if (res.data.data.id !== undefined && res.data.data.id) {
                        delete res.data.data.id;
                        onInputHandle(res.data.data.name, "name");
                        onInputHandle(res.data.data.nominee, "nominee");
                        onInputHandle(res.data.data.gender, "gender");
                        onInputHandle(res.data.data.address, "address");
                        onInputHandle(res.data.data.village, "village");
                        onInputHandle(res.data.data.panchayat, "panchayat");
                        onInputHandle(res.data.data.taluko, "taluko");
                        onInputHandle(res.data.data.district, "district");
                        onInputHandle(res.data.data.closed_at, "closed_at");
                        onInputHandle(res.data.data.frozen_at, "frozen_at");
                        onInputHandle(
                            res.data.data.contact_number,
                            "contact_number"
                        );
                        onInputHandle(
                            res.data.data.alternate_number,
                            "alternate_number"
                        );
                    }
                });
        }
    };
    return (
        <>
            <CContainer fluid={true}>
                <CRow>
                    <CCard>
                        <CCardBody>
                            <CCardTitle>
                                Customer Account
                                {d["customer_account_number"] !== undefined &&
                                    d["customer_account_number"] && (
                                        <div className={"float-end"}>
                                            <CurrentBalance data={d}>
                                                <CButton color="info">
                                                    {
                                                        d[
                                                            "customer_account_number"
                                                        ]
                                                    }
                                                </CButton>
                                            </CurrentBalance>
                                        </div>
                                    )}
                            </CCardTitle>
                            <CCardText>
                                Basic Information Regarding Customer which will
                                be used for Ledger Keeping and more.
                            </CCardText>
                            {d && !d.id && (
                                <>
                                    <CRow>
                                        <CCol
                                            sm={12}
                                            md={12}
                                            className={"mt-1"}
                                        >
                                            <CInputGroup>
                                                <CButton
                                                    size={"sm"}
                                                    color={"danger"}
                                                >
                                                    AUTO COMPLETE ONLY{" "}
                                                </CButton>
                                                <CButton
                                                    size={"sm"}
                                                    color={"warning"}
                                                >
                                                    Provide Customer Number
                                                    Example #UYS753GH, Also
                                                    double check it before
                                                    Customer Account because it
                                                    will be used to create
                                                    memo/transaction.
                                                </CButton>
                                            </CInputGroup>
                                        </CCol>
                                        <CCol
                                            sm={12}
                                            md={12}
                                            className={"mt-1"}
                                        >
                                            <CFormFloating className="mb-3">
                                                <CInputGroup>
                                                    <CFormInput
                                                        onChange={(e) => {
                                                            getCustomerAccountNumber(
                                                                e.target.value
                                                            );
                                                        }}
                                                    />
                                                </CInputGroup>
                                            </CFormFloating>
                                        </CCol>
                                    </CRow>
                                </>
                            )}
                            {d?.id && (
                                <>
                                    <CRow>
                                        <CCol sm={12} md={6} className={"mt-2"}>
                                            <CInputGroup className="mb-3">
                                                {!readOnly && (
                                                    <>
                                                        <CButton color="danger">
                                                            Freeze a selected
                                                            date so that it
                                                            cannot be searched
                                                            anywhere.
                                                        </CButton>
                                                        <CButton color="warning">
                                                            {getDate__frozen_at()
                                                                ? "Frozen at"
                                                                : "Freeze it"}
                                                        </CButton>
                                                    </>
                                                )}
                                                {readOnly && (
                                                    <CButton
                                                        color={
                                                            getDate__frozen_at()
                                                                ? "danger"
                                                                : "success"
                                                        }
                                                    >
                                                        {getDate__frozen_at()
                                                            ? "Frozen at"
                                                            : "Active Account"}
                                                    </CButton>
                                                )}
                                                <DatePicker
                                                    disabled={readOnly}
                                                    onChange={(e) => {
                                                        onInputHandle(
                                                            e,
                                                            "frozen_at"
                                                        );
                                                    }}
                                                    value={
                                                        getDate__frozen_at() ||
                                                        ""
                                                    }
                                                    className={"form-control"}
                                                />
                                            </CInputGroup>
                                        </CCol>
                                    </CRow>
                                    {d?.id && (
                                        <CRow>
                                            <CCol
                                                sm={12}
                                                md={6}
                                                className={"mt-2"}
                                            >
                                                <CInputGroup className="mb-3">
                                                    {!readOnly && (
                                                        <>
                                                            <CButton color="danger">
                                                                Close with a
                                                                selected date.
                                                            </CButton>
                                                            <CButton color="warning">
                                                                {getDate()
                                                                    ? "Closed at"
                                                                    : "Close it"}
                                                            </CButton>
                                                        </>
                                                    )}
                                                    {readOnly && (
                                                        <CButton
                                                            color={
                                                                getDate()
                                                                    ? "danger"
                                                                    : "success"
                                                            }
                                                        >
                                                            {getDate()
                                                                ? "Closed at"
                                                                : "Running Account"}
                                                        </CButton>
                                                    )}
                                                    <DatePicker
                                                        disabled={readOnly}
                                                        onChange={(e) => {
                                                            onInputHandle(
                                                                e,
                                                                "closed_at"
                                                            );
                                                        }}
                                                        value={getDate() || ""}
                                                        className={
                                                            "form-control"
                                                        }
                                                    />
                                                </CInputGroup>
                                            </CCol>
                                        </CRow>
                                    )}
                                </>
                            )}
                            <CRow>
                                <CCol sm={12} md={6} className={"mt-2"}>
                                    <CInputGroup className="mb-3">
                                        <CButton color="warning">
                                            Account Creation Date
                                        </CButton>
                                        <DatePicker
                                            disabled={readOnly}
                                            onChange={(e) => {
                                                onInputHandle(e, "created_at");
                                            }}
                                            value={getDate__created_at() || ""}
                                            className={"form-control"}
                                        />
                                    </CInputGroup>
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol sm={12} md={6}>
                                    <CFormFloating className="mb-3">
                                        <CFormInput
                                            type="text"
                                            onChange={(e) => {
                                                onInputHandle(
                                                    e.target.value,
                                                    "name"
                                                );
                                            }}
                                            defaultValue={d["name"] || ""}
                                            disabled={readOnly}
                                            readOnly={readOnly}
                                        />
                                        <CFormLabel htmlFor="floatingInput">
                                            Name
                                        </CFormLabel>
                                    </CFormFloating>
                                    <CRow>
                                        <CCol>
                                            <CFormFloating className="mb-3">
                                                <CFormInput
                                                    type="text"
                                                    onChange={(e) => {
                                                        onInputHandle(
                                                            e.target.value,
                                                            "nominee"
                                                        );
                                                    }}
                                                    defaultValue={
                                                        d["nominee"] || ""
                                                    }
                                                    disabled={readOnly}
                                                    readOnly={readOnly}
                                                />
                                                <CFormLabel htmlFor="floatingInput">
                                                    Nominee Name
                                                </CFormLabel>
                                            </CFormFloating>
                                        </CCol>
                                    </CRow>
                                </CCol>
                                <CCol sm={12} md={6} className={"mt-2"}>
                                    <CFormLabel htmlFor="basic-url">
                                        Gender
                                    </CFormLabel>
                                    <CFormFloating>
                                        <CFormCheck
                                            inline
                                            type="radio"
                                            name="gender"
                                            value="male"
                                            label="Male"
                                            onChange={(e) => {
                                                onInputHandle(
                                                    e.target.value,
                                                    "gender"
                                                );
                                            }}
                                            disabled={readOnly}
                                            readOnly={readOnly}
                                            defaultChecked={
                                                d["gender"] &&
                                                d["gender"] === "male"
                                            }
                                        />
                                        <CFormCheck
                                            inline
                                            type="radio"
                                            name="gender"
                                            value="female"
                                            label="Female"
                                            onChange={(e) => {
                                                onInputHandle(
                                                    e.target.value,
                                                    "gender"
                                                );
                                            }}
                                            disabled={readOnly}
                                            readOnly={readOnly}
                                            defaultChecked={
                                                d["gender"] &&
                                                d["gender"] === "female"
                                            }
                                        />
                                        <CFormCheck
                                            inline
                                            type="radio"
                                            name="gender"
                                            value="other"
                                            label="Other"
                                            onChange={(e) => {
                                                onInputHandle(
                                                    e.target.value,
                                                    "gender"
                                                );
                                            }}
                                            disabled={readOnly}
                                            readOnly={readOnly}
                                            defaultChecked={
                                                d["gender"] &&
                                                d["gender"] === "other"
                                            }
                                        />
                                    </CFormFloating>
                                </CCol>
                                <CCol sm={12} md={6} className={"mt-2"}>
                                    <CFormLabel htmlFor="basic-url">
                                        Account Type
                                        {d.account_type !== undefined &&
                                            d.account_type && (
                                                <>
                                                    :{" "}
                                                    {
                                                        account_type[
                                                            d.account_type
                                                        ]
                                                    }
                                                </>
                                            )}
                                    </CFormLabel>
                                    {!d.id && (
                                        <>
                                            <CFormFloating>
                                                <CFormCheck
                                                    inline
                                                    type="radio"
                                                    name="account_type"
                                                    value="L"
                                                    label={account_type.L}
                                                    onChange={(e) => {
                                                        onInputHandle(
                                                            e.target.value,
                                                            "account_type"
                                                        );
                                                    }}
                                                    disabled={readOnly}
                                                    readOnly={readOnly}
                                                    defaultChecked={
                                                        d["account_type"] &&
                                                        d["account_type"] ===
                                                            "L"
                                                    }
                                                />
                                                <CFormCheck
                                                    inline
                                                    type="radio"
                                                    name="account_type"
                                                    value="S"
                                                    label={account_type.S}
                                                    onChange={(e) => {
                                                        onInputHandle(
                                                            e.target.value,
                                                            "account_type"
                                                        );
                                                    }}
                                                    disabled={readOnly}
                                                    readOnly={readOnly}
                                                    defaultChecked={
                                                        d["account_type"] &&
                                                        d["account_type"] ===
                                                            "S"
                                                    }
                                                />
                                            </CFormFloating>
                                        </>
                                    )}
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol sm={12} md={6} className={"mt-2"}>
                                    <CFormFloating className="mb-3">
                                        <CInputGroup>
                                            <CInputGroupText>
                                                Address
                                            </CInputGroupText>
                                            <CFormTextarea
                                                aria-label="With textarea"
                                                onChange={(e) => {
                                                    onInputHandle(
                                                        e.target.value,
                                                        "address"
                                                    );
                                                }}
                                                disabled={readOnly}
                                                readOnly={readOnly}
                                                defaultValue={
                                                    d["address"] || ""
                                                }
                                            />
                                        </CInputGroup>
                                    </CFormFloating>
                                </CCol>
                                <CCol sm={12} md={6} className={"mt-2"}>
                                    <CFormFloating className="mb-3">
                                        <CFormInput
                                            type="text"
                                            onChange={(e) => {
                                                onInputHandle(
                                                    e.target.value,
                                                    "village"
                                                );
                                            }}
                                            defaultValue={d["village"] || ""}
                                            disabled={readOnly}
                                            readOnly={readOnly}
                                        />
                                        <CFormLabel htmlFor="floatingInput">
                                            Village
                                        </CFormLabel>
                                    </CFormFloating>
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol sm={12} md={4} className={"mt-2"}>
                                    <CFormFloating className="mb-3">
                                        <CFormInput
                                            type="text"
                                            onChange={(e) => {
                                                onInputHandle(
                                                    e.target.value,
                                                    "panchayat"
                                                );
                                            }}
                                            defaultValue={d["panchayat"] || ""}
                                            disabled={readOnly}
                                            readOnly={readOnly}
                                        />
                                        <CFormLabel htmlFor="floatingInput">
                                            Panchayat
                                        </CFormLabel>
                                    </CFormFloating>
                                </CCol>
                                <CCol sm={12} md={4} className={"mt-2"}>
                                    <CFormFloating className="mb-3">
                                        <CFormInput
                                            type="text"
                                            onChange={(e) => {
                                                onInputHandle(
                                                    e.target.value,
                                                    "taluko"
                                                );
                                            }}
                                            defaultValue={d["taluko"] || ""}
                                            disabled={readOnly}
                                            readOnly={readOnly}
                                        />
                                        <CFormLabel htmlFor="floatingInput">
                                            Taluko
                                        </CFormLabel>
                                    </CFormFloating>
                                </CCol>
                                <CCol sm={12} md={4} className={"mt-2"}>
                                    <CFormFloating className="mb-3">
                                        <CFormInput
                                            type="text"
                                            onChange={(e) => {
                                                onInputHandle(
                                                    e.target.value,
                                                    "district"
                                                );
                                            }}
                                            defaultValue={d["district"] || ""}
                                            disabled={readOnly}
                                            readOnly={readOnly}
                                        />
                                        <CFormLabel htmlFor="floatingInput">
                                            District
                                        </CFormLabel>
                                    </CFormFloating>
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol sm={12} md={6} className={"mt-2"}>
                                    <CInputGroup className="mb-3">
                                        <CInputGroupText>
                                            Contact Number
                                        </CInputGroupText>
                                        <CFormInput
                                            onChange={(e) => {
                                                onInputHandle(
                                                    e.target.value,
                                                    "contact_number"
                                                );
                                            }}
                                            defaultValue={
                                                d["contact_number"] || ""
                                            }
                                            disabled={readOnly}
                                            readOnly={readOnly}
                                        />
                                    </CInputGroup>
                                </CCol>
                                <CCol sm={12} md={6} className={"mt-2"}>
                                    <CInputGroup className="mb-3">
                                        <CInputGroupText>
                                            Alternate Number
                                        </CInputGroupText>
                                        <CFormInput
                                            onChange={(e) => {
                                                onInputHandle(
                                                    e.target.value,
                                                    "alternate_number"
                                                );
                                            }}
                                            defaultValue={
                                                d["alternate_number"] || ""
                                            }
                                            disabled={readOnly}
                                            readOnly={readOnly}
                                        />
                                    </CInputGroup>
                                </CCol>
                            </CRow>
                            {!d?.id && (
                                <FormFields
                                    d={d}
                                    readOnly={false}
                                    onInputHandle={(e, name) => {
                                        if (e?.target?.value) {
                                            onInputHandle(e.target.value, name);
                                        } else {
                                            onInputHandle(e, name);
                                        }
                                    }}
                                    getDate__created_at={
                                        getDate__memo_created_at
                                    }
                                    name_for_created_at={"memo_created_at"}
                                    customer_account_number={""}
                                />
                            )}
                        </CCardBody>
                        <CCardFooter>
                            <CRow>
                                <CCol>
                                    <CButtonGroup
                                        role="group"
                                        aria-label="Basic mixed styles example"
                                    >
                                        {auth.is_admin && (
                                            <>
                                                {action === "edit" && (
                                                    <CButton
                                                        size="lg"
                                                        onClick={() => {
                                                            submitForm();
                                                        }}
                                                        component="input"
                                                        type="submit"
                                                        color="primary"
                                                        value="Submit"
                                                    />
                                                )}
                                            </>
                                        )}
                                        {action === "search" && !readOnly && (
                                            <CButton
                                                size="lg"
                                                onClick={() => {
                                                    props.onSearch(d);
                                                }}
                                                component="input"
                                                type="submit"
                                                color="primary"
                                                value="Search"
                                            />
                                        )}
                                        {action !== "search" && (
                                            <CButton
                                                size="lg"
                                                onClick={() => {
                                                    backToHome();
                                                }}
                                                component="input"
                                                type="submit"
                                                color="secondary"
                                                value="Back"
                                            />
                                        )}
                                    </CButtonGroup>
                                </CCol>
                                {auth.is_admin && (
                                    <>
                                        {d.id !== undefined &&
                                            action === "delete" && (
                                                <CCol>
                                                    <CButton
                                                        size="lg"
                                                        onClick={() => {
                                                            destroyForm();
                                                        }}
                                                        component="input"
                                                        type="submit"
                                                        color="danger"
                                                        value="Destroy"
                                                        className={"float-end"}
                                                    />
                                                </CCol>
                                            )}
                                    </>
                                )}
                            </CRow>
                        </CCardFooter>
                    </CCard>
                </CRow>
            </CContainer>
        </>
    );
};
export default Common;
